// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"840":"bc903fd6","926":"ec62bc58"}[chunkId] + ".chunk.js";
};